import { Model } from "@lernetz/ts-lib";
import {languageService} from "../../services/lang";
import {paramService} from "../../services/params.service";
import { router, wizardStack, toRoute } from "../../services/router";
import { WizardSegment } from "./wizard.segment";

export class WizardQuestion extends Model implements IWizardQuestion {
    id: string;
    question: string;
    answers: IWizardAnswer[];
    level: any;
    activeTags = [];
    currentLang: any;
    constructor(dto) {
        super(dto);
        this.currentLang = languageService.currentLang;
    }

    back() {
        router.current.path.search(/wizard\/.*/) !== -1
            ? wizardStack[this.currentLang].pop()
            : router.toRoute("wizard");
    }
}

export class WizardAnswer extends Model implements IWizardAnswer {
    id: string;
    answer: string;
    action?: WizardQuestion;
    tags: any[];
    overrideTags: boolean;
    currentLang: string;

    constructor(dto) {
        super(dto);
        this.currentLang = languageService.currentLang;
    }

    goTo(level, activeTags) {
        const newTags = this.mutateActiveTags(activeTags, this.tags, this.overrideTags);
        const followUpQuestion = this.action;
        if (followUpQuestion) {
            followUpQuestion.level = level + 1;
            followUpQuestion.activeTags = newTags;
            wizardStack[this.currentLang].push(new WizardSegment(followUpQuestion));
        } else {
            toRoute('results', { query: paramService.createParams(newTags)});
        }
    }

    private mutateActiveTags(previousTags, newTags, overrideTags?: boolean) {
        return overrideTags ? [ ...previousTags, ...newTags ] : [ ...newTags ];
    }

}

interface IWizardQuestion {
    id: string;
    answers: IWizardAnswer[];
}

interface IWizardAnswer {
    id: string;
    answer: string;
    action?: IWizardQuestion;
    tags: any[];
}
